import { render } from "./managing-country-read-row.vue?vue&type=template&id=5bbc20d3&ts=true"
import script from "./managing-country-read-row.vue?vue&type=script&lang=ts"
export * from "./managing-country-read-row.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__